import Provider from "./src/context/LangContext"
import "./src/style/global.scss"

export const wrapRootElement = Provider
